export enum MediaSuffix {
  primaryImage = 1,
  secondaryImage,
  video,
}
